module.exports = __webpack_public_path__ + "img/footer_icons.a7b2e986.png";